// extracted by mini-css-extract-plugin
module.exports = {"link":"_36R6S","GamingButton":"_38mCS","gamingButton":"_38mCS","label":"_128Ro","left":"_1-1cW","right":"_3dMBj","gradient":"cp8ci"};